import './css/theme.css?raw'
import './css/main.css'
import 'hammerjs'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'

import { App } from './App'
import { container } from './container'

const router = createBrowserRouter([{ path: '*', Component: App }])

const root = createRoot(container!)
root.render(<RouterProvider router={router} />)
